import PrimaryDefaultButton from '@/components/buttons/primary/DefaultButton';
import PrimaryInnerGlowButton from '@/components/buttons/primary/InnerGlowButton';
import PrimaryOuterGlowButton from '@/components/buttons/primary/OuterGlowButton';

export default PrimaryInnerGlowButton;

export { PrimaryDefaultButton, PrimaryInnerGlowButton, PrimaryOuterGlowButton };
